module.exports = __webpack_public_path__ + "static/media/bottleqt.6a00705e.svg";